/**
 * Compose a gift-card recipient's display name from its optional first/last name
 * parts (stored on the card as `recipient_first_name` / `recipient_last_name`).
 *
 * Null-safe: trims each part, drops the blanks, and returns `null` when neither
 * is present — so a certificate can omit the "To" line entirely, and each surface
 * can fall back to the attached holder name when there's no recorded recipient.
 */
export const giftCardRecipientName = (
  firstName?: string | null,
  lastName?: string | null,
): string | null => {
  const name = [firstName, lastName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" ");
  return name || null;
};
